jQuery(document).ready(function () {  
	console.log('HELLO-CUSTOM')
  	var appUrl = "https://store.xecurify.com";
	var flagfield;
	var otpvalue;

	$('head').append('<link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.min.css">');
	$('head').append('<script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput-jquery.js"></script>');
	$('head').append('<script src="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput-jquery.min.js"></script>');
	$('head').append('link href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/intlTelInput.min.js">');
    $('head').append('<script src="https://code.jquery.com/jquery-3.6.0.min.js" type="text/javascript"></script>');
	$('head').append('<meta name="viewport" content="width=device-width, initial-scale=1" />');
    $('head').append("<form id='verifyotps' action='" + appUrl + "/moas/rest/shopify/api/auth/register/verifyOtp2fa' method='GET'> " +
		"<input type='text' id='txid' name='txid'></input>" +
		// "<input type='text' id='mobilenumber' name='mobilenumber'></input>" +
		"<input type='text' id='otp' name='otp'></input>" +
		"<input type='text' id='shop' name='shop'></input>" +
		"<input type='text' id='shopcheckouturl' name='shopcheckouturl'></input>" +
        "<input type='text' id='first_name' name='first_name'></input>" +
        "<input type='text' id='last_name' name='last_name'></input>" +
        "<input type='text' id='email' name='email'></input>" +
        "<input type='text' id='password' name='password'></input>" +
		"</form>");
  
  var checkout_url = "/account";
  var Hash_String = window.location.search;
var CheckoutUrl = "";
const Hash_Param = new URLSearchParams(Hash_String);
if (Hash_Param.has('hash')) {
	// console.log('In setting hash');
	document.cookie = "storefront_digest=" + Hash_Param.get('hash') + "; path=/";
	var shop_name = window.location.hostname;
	window.location.href = "https://" + shop_name;
}
if (Hash_Param.has('checkout_url')) {
	CheckoutUrl = "checkout";

}
else {
	CheckoutUrl = '/account';
}



    
 var cartCookieValue =  getCookie("cart");  
 if (typeof cartCookieValue !== 'undefined'){
    createCookie("cart",cartCookieValue,15);
} 
  
  let accountCreateHandle = document.getElementById('accountCreate');
  let registerOTPHandle = document.getElementById('registerOTP');
  // let NumberHandle = document.getElementById('mobileNumbers');
  let emailHandle = document.getElementById('emailvalue');
  let otpHandle = document.getElementById('OTPval');
  let otpverifyHandle = document.getElementById('registerOTPs');
  let mobileErrorHandlers = document.getElementById("mobileErrors");
  let createHandle = document.getElementById("newSubmit");
  let otpnumberhandle = document.getElementById("OTPnumber");
  let resendbuttonHandle = document.getElementById("resendButtons");
  let resendHandle = document.getElementById("resendButtonnew");
  var txId;
  let formHandle = document.getElementById('RegistrationForm');
  var phoneNumber;
  var contact;
  var flag = document.createElement('style');
  	
      
        registerOTPHandle.addEventListener('click', function () {
        email = emailHandle.value;
		// phoneNumber = flagfield.getNumber();
		// contact = phoneNumber.substring(1);
        if (email == '') { alert('Email is missing'); return }
		if (email.includes('@xecurify.com') === false && email.includes('@kiddieacademy.net') === false && 
            email.includes('@kiddieacademy.com') === false && email.includes('@eeveducation.com') === false
           && email.includes('@cumuluscollections.com') === false && email.includes('@childsplayusa.com') === false) { alert('Email domain must use either \'kiddieacademy.com\' or \'kiddieacademy.net\''); return }
        mobileErrorHandlers.innerHTML = "Please wait. We are sending OTP on your Email";
		$.ajax(
			{
					url: appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&to=" + email+"&action=register" ,
				type: "GET",
				headers: { 'Customer-Key': '19682', 'Timestamp': '1611582714234', 'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db' },
				success: function (result) {console.log(result);

					if (result.status == 'SUCCESS') {

						mobileErrorHandlers.innerHTML = "";
                      
                        emailHandle.style = 'display:inline-block;'
                        
                        otpHandle.style = 'display:inline-block'

						otpnumberhandle.style = 'display:inline-block'
                        
                        resendbuttonHandle.style = 'display:inline-block'

						resendHandle.style = 'display:inline-block'

						registerOTPHandle.style = 'display:none'

						// accountCreateHandle.style = 'display:inline-block; color:#fff;'
                        
                        accountCreateHandle.disabled = false;
                      
                        emailHandle.setAttribute("size", "100");
                      
						// console.log(result);
						txId = result.txId;

					}
					else if (result.status == 'false') {
						mobileErrorHandlers.innerHTML = "Mobile Number entered in invalid. Please check or add mobile number to your profile";
					}
				},
				error: function (xhr, status, p3, p4) {
					var err = "Error " + " " + status + " " + p3;
					if (xhr.responseText && xhr.responseText[0] == "{")
						err = JSON.parse(xhr.responseText).message;
					alert(err);
                 
				}
			});
	}); 
  
  resendbuttonHandle.addEventListener('click', function() {
        email = emailHandle.value;
		// contact = phoneNumber.substring(1);
        if (email == '') { alert('Email is missing'); return }
    	if (email.includes('@kiddieacademy.com') === false && email.includes('@kiddieacademy.net') === false && email.includes('@xecurify.com') === false
           && email.includes('@eeveducation.com') === false && email.includes('@cumuluscollections.com') === false && email.includes('@childsplayusa.com') === false) { alert('Email domain must use either \'kiddieacademy.com\' or \'kiddieacademy.net\''); return }

        mobileErrorHandlers.innerHTML = "Please Wait. We are sending OTP again.";
		$.ajax(
          {
			url: appUrl + "/moas/rest/shopify/api/auth/otprequest2fa?shop=" + window.location.hostname + "&to=" + email+"&action=register" ,
			type: "GET",
			headers: {
				'Customer-Key': '19682',
				'Timestamp': '1611582714234',
				'Authorization': 'f32201d6adfd872acc19df58b606166e5e214678275998c2900a71978f1734e22bf8b71b4c0588b5d5022e497008bb9b76d182156dd4f371c1435935d517e0db'
			},
			success: function(result) {

				if (result.status == 'SUCCESS') {

					    mobileErrorHandlers.innerHTML = "OTP has been resent to your email.";

					    txId = result.txId;

				} else if (result.status == 'false') {
					mobileErrorHandler.innerHTML = "The entered email is invalid. Please check your email or add your email to your profile ";
				}
			},
			error: function(xhr, status, p3, p4) {
				var err = "Error " + " " + status + " " + p3;
				if (xhr.responseText && xhr.responseText[0] == "{")
					err = JSON.parse(xhr.responseText).message;
				alert(err);
			}
		});
	});

  
  document.getElementById("accountCreate").addEventListener('click', function () {
    
    if ((document.getElementById('OTPval').value == '') || (document.getElementById('RegisterForm-FirstName').value == '') || (document.getElementById('RegisterForm-LastName').value == '') || (document.getElementById('emailvalue').value == ''))
    { alert('Required field is missing'); return }

    
	document.getElementById('verifyotps').elements.namedItem("txid").value = txId;
	document.getElementById('verifyotps').elements.namedItem("shop").value = window.location.hostname
	document.getElementById('verifyotps').elements.namedItem("otp").value = otpHandle.value
	// document.getElementById('verifyotps').elements.namedItem("mobilenumber").value = contact
	document.getElementById('verifyotps').elements.namedItem("shopcheckouturl").value = CheckoutUrl
    document.getElementById('verifyotps').elements.namedItem("first_name").value = document.getElementById('RegisterForm-FirstName').value
    document.getElementById('verifyotps').elements.namedItem("last_name").value = document.getElementById('RegisterForm-LastName').value
    document.getElementById('verifyotps').elements.namedItem("email").value = document.getElementById('emailvalue').value
    // document.getElementById('verifyotps').elements.namedItem("password").value = document.getElementById("passwords").value 
	document.getElementById('verifyotps').submit();

});


if (Hash_Param.has('txid')) {
	mobileErrorHandlers.innerHTML = "You have entered invalid OTP. Please enter valid OTP to create an account"
                        
    otpHandle.style = 'display:inline-block'

    otpnumberhandle.style = 'display:inline-block'
                        
    resendbuttonHandle.style = 'display:inline-block'

    resendHandle.style = 'display:inline-block'
    
	// accountCreateHandle.style = 'display:inline-block; color:#fff; background:#85754e'
                        
    accountCreateHandle.disabled = false;
                          
	txId = Hash_Param.get('txid');
	contact = Hash_Param.get('mobilenumber');
    
    }  

});

function getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(";").forEach(function(el) {
      let [key,value] = el.split("=");
      cookie[key.trim()] = value;
    });
    return cookie[cookieName];
}

function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toGMTString();
    }
    else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
}


	
        
     


      
